import React, { useState } from "react";
import RejectedCarsList from "../components/RejectedCars/RejectedCarsList";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "../../../utils/constants/routes";

const RejectedCars = () => {

    // useNavigate...
  const navigate = useNavigate();
  // useNavigate...

  // useLocation...
  const location = useLocation();
  // useLocation...

  const Vehicle_Id = location?.pathname?.split?.(`${routes.myOrders}/`)?.[1];

  // useState variables start...
  const [detailView, setDetailView] = useState(false);
  const [selectedCar, setSelectedCar] = React.useState(null);
  // useState variables end...

  if (Vehicle_Id) {
    // return <LiveAuctionCarDetail 
    //   selectedCar={selectedCar}
    //   setSelectedCar={setSelectedCar}
    // />;
    return <></>
  }
  return <RejectedCarsList 
    selectedCar={selectedCar}
    setSelectedCar={setSelectedCar}
    onCarClick={(car) => {
      // console.log(car, `onCarClick`)
      // setSelectedCar(car);
      // setDetailView(true);
      // navigate(`${routes.dashboardNavigation}${routes}/${car?.Vehicle_Id}`);
    }}
  />;
};

export default RejectedCars;
